import { Trans } from '@lingui/react/macro'
import { useNavigate } from 'react-router-dom'
import { useBizUsers } from '../BizApi'
import { cn } from '@jotta/utils/css'

export function BizActionButtonCreateUser({
  className,
}: {
  className?: string
}) {
  const { canCreateUser } = useBizUsers()
  const navigate = useNavigate()
  return (
    <button
      data-testid="BizCreateUser"
      onClick={() => navigate('./create')}
      disabled={!canCreateUser}
      className={cn('btn btn-primary', className)}
    >
      <Trans>Create user</Trans>
    </button>
  )
}
